export function getProvider(provider: BikeProvider) {
  if (
    provider === 'ICE' ||
    provider === 'AIRBUS' ||
    provider === 'CAMPUSHEILBRONN' ||
    provider === 'UNKNOWN'
  ) {
    return 'callabike'
  } else {
    return provider.toLowerCase()
  }
}
